import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import CONFIG from "@/assets/js/config.js";

export default {
    name: "gradingDetail",
    components: {
        MainLayout,
        Loading
    },

    data() {
        return {
            isLoading: false,
            gradingInfo: {},
            noDataMsg: CONFIG.NO_DATA_EXIST,
        };
    },

    methods: {
        async getGradingDetail() {
            try {
                this.isLoading = true;
        
                const response = await axios.get("/grading/gradingDetail/" + this.$route.params.student_id, {
                    params: {
                        exam_id: this.$route.params.exam_id
                    },
                });
                if (response.data[0] != undefined) {
                    this.gradingInfo = response.data[0];
                }
            } catch (error) {
                if (error.response && error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                }
                console.error("Grading Detail API Error", error);
            } finally {
                this.isLoading = false;
            }
        },

        showList() {
            this.$router.push({
                path: "/grading/list"
            });
        },
    },
    
    mounted() {
        this.isLoading = true;
        this.getGradingDetail();
    },
};
